import React from 'react';

import { ReactComponent as SidebarLogoIcon } from './source/sidebar-logo.svg';
import { Root } from './shared/styled';

import type { IconProps } from './shared/types';

const SidebarLogo = (props: IconProps): React.ReactElement => {
    return (
        <Root {...props}>
            <SidebarLogoIcon />
        </Root>
    );
};

export { SidebarLogo };
